/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { FranchiseMonthlyRestService } from '@gh/builder-shared-data';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import {
  FranchiseReportFilterList,
  franchiseReportFilterListFromDto,
  franchiseReportFilterListToDto,
} from '../resources/franchise-monthly-report.model';

@Injectable()
export class FranchiseMonthlyReportBusinessService {
  constructor(private restService: FranchiseMonthlyRestService) {
  }

  initView(): any {
    return {
      reportFilter: this.init(),
    };
  }

  init(): Observable<FranchiseReportFilterList> {
    return this.restService.init().pipe(map$(franchiseReportFilterListFromDto));
  }

  update(reportFilter: FranchiseReportFilterList): Observable<FranchiseReportFilterList> {
    return this.restService.update(franchiseReportFilterListToDto(this._clearWhsDetailsForNoWhs(reportFilter))).pipe(
      map$(franchiseReportFilterListFromDto));
  }

  private _clearWhsDetailsForNoWhs(report: FranchiseReportFilterList): FranchiseReportFilterList {
    if (!report.whs) {
      report.whsDetails = '';
    }
    report.historySettings.forEach((item) => {
      if (!item.whs) {
        item.whsDetails = '';
      }
    });
    return report;
  }
}
